import { Step, State } from '../../../types/tour';

export const buildState = (steps: Step[], current: number): State => {
  return {
    steps,
    current,
    first: 0,
    last: steps.length - 1,
    showPrev: current !== 0,
    showNext: true,
    modal: undefined,
  };
};

export const initialState: State = buildState([], 0);
